import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpSchemaElementApperance } from './op-schema-element-apperance'
import { OpDescr } from '../core/op-descr'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpFile } from '../core/op-file'

export class OpSchemaElement {
    //Properties
    public x: number
    public y: number
    public width: number
    public height: number
    public name: string
    public elementType: Enums.SchemaElementType
    public idDataType: number
    public indexNbr: number
    public description: string
    public value: any
    public isEditable: boolean
    public descriptionVisible: boolean
    public unitVisible: boolean
    public valueHidden: boolean
    //Properties end

    //NavigationProperties
    public schemaElementApperance: OpSchemaElementApperance[]
    public descriptions: OpDescr[]
    //NavigationProperties end

    constructor(opObj: any) {
        if (opObj) {
            this.x = opObj.X
            this.y = opObj.Y
            this.width = opObj.Width
            this.height = opObj.Height
            this.name = opObj.Name
            this.elementType = opObj.ElementType
            this.idDataType = opObj.IdDataType
            this.indexNbr = opObj.IndexNbr
            this.description = opObj.Description
            this.value = opObj.Value
            this.isEditable = opObj.IsEditable
            this.descriptionVisible = opObj.DescriptionVisible
            this.unitVisible = opObj.UnitVisible
            this.valueHidden = opObj.ValueHidden
            if (opObj.SchemaElementApperance)
                this.schemaElementApperance = opObj.SchemaElementApperance.map(data => { return new OpSchemaElementApperance(data) })
            if (opObj.Descriptions)
                this.descriptions = opObj.Descriptions.map(data => { return new OpDescr(data) })
        }
        if (!this.schemaElementApperance)
            this.schemaElementApperance = []
        if (!this.descriptions)
            this.descriptions = []
    }
}